const NotFound = () => <p>Sorry, nothing here</p>

export default NotFound;